import { Component, OnInit } from '@angular/core';
// import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
// import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';

import { IdleUserService } from './core/services/idleuser.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isUserIdle: boolean = false;


  constructor(private idleUserService: IdleUserService,private router:Router) {}

  ngOnInit() {
    this.idleUserService.userInactive.subscribe(isIdle => this.isUserIdle = isIdle);



    console.log(this.isUserIdle)
    if(this.isUserIdle == true ){
      this.router.navigate(['/auth/login']);
     
    }
  }


  
  

  // reset() {
  //   console.log('Reset idle timer');
  //   this.isUserIdle = false;
  //   this.idleUserService.reset();
  // }
}